import {
  Component,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
} from '@angular/core';
import Quill from 'quill';
import type { Delta } from 'quill/core';

@Component({
  selector: 'app-quill',
  imports: [],
  templateUrl: './quill.component.html',
  styleUrl: './quill.component.scss',
})
export class QuillComponent implements AfterViewInit {
  @Input() content!: Delta | undefined;
  @Input() allowImages = false;

  @ViewChild('editor', { static: false }) editorElement!: ElementRef;
  private quill: Quill | undefined;

  delta: Delta | undefined;
  ngAfterViewInit(): void {
    const toolbar: unknown[] = [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
    ];
    if (this.allowImages) {
      toolbar.push(['image']);
    }

    this.quill = new Quill(this.editorElement.nativeElement, {
      theme: 'snow',
      modules: {
        toolbar,
      },
    });

    if (this.content) {
      this.quill?.setContents(this.content);
    }
  }

  getContent(): { delta: Delta; html: string } {
    if (!this.quill) {
      throw new Error('Quill not initialized');
    }
    return {
      delta: this.quill.getContents(),
      html: this.quill.getSemanticHTML(0, this.quill.getLength()) || '',
    };
  }
}
